// eslint-disable-next-line
export const removeEmptyObjectFields = (obj: any) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => {
      if (Array.isArray(v)) {
        return v.length !== 0;
      }
      return !!v || v === 0;
    })
  );
};

export const createDownloadFile = (base64: string, fileName: string): void => {
  const url = window.URL.createObjectURL(new Blob([base64]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
};

export const formatAMPM = (time: string | null): string | null => {
  if (time) {
    const arr = time.split(':');
    let hours = Number(arr[0]);
    let minutes: number | string = Number(arr[1]);
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour 0 should be 12
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  } else return null;
};

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
